import buttonTheme from './components/button';
import inputTheme from './components/input';
import tabsTheme from './components/tabs';
import cardsTheme from './components/card';
import modalTheme from './components/modal';
import linkTheme from './components/link';
import menuTheme from './components/menu';
import popoverTheme from './components/popover';
import tableTheme from './components/table';
import checkboxTheme from './components/checkbox';
import switchTheme from './components/switch';
import textTheme from './components/text';
import tagTheme from './components/tag';
import drawerTheme from './components/drawer';
import badgeTheme from './components/badge';
import selectTheme from './components/select';
import textareaTheme from './components/textarea';
import accordionTheme from './components/accordion';

const customTheme = {
  semanticTokens: {
    colors: {
      'texasBrand.50': { default: '#fdecea', _dark: '#3c2f22' },
      'texasBrand.100': { default: 'texas.burntSienna.50', _dark: '#4e3d2a' },
      'texasBrand.200': { default: '#e08070', _dark: 'texas.sand.50' },
      'texasBrand.300': { default: '#d57060', _dark: 'texas.sand.75' },
      'texasBrand.400': { default: '#ca6050', _dark: 'texas.sand.100' },
      'texasBrand.500': {
        default: 'texas.burntSienna.500',
        _dark: 'texas.sand.30',
      },
      'texasBrand.600': {
        default: 'texas.burntSienna.100',
        _dark: 'texas.sand.20',
      },
      'texasBrand.700': { default: '#9e3d20', _dark: 'texas.sand.10' },
      'texasBrand.800': { default: '#7d3019', _dark: '#F8E2C8' },
      'texasBrand.900': { default: '#5c231e', _dark: '#F3DABE' },
      'navigation.globalBackground': {
        default: '#221f20',
        _dark: '#221f20',
      },
      'navigation.globalMuted': {
        default: '#bfbab4',
        _dark: '#bfbab4',
      },
      'navigation.contextBackground': { default: 'white', _dark: 'gray.800' },
      'navigation.contextBorder': {
        default: '#d8d3c8',
        _dark: 'whiteAlpha.300',
      },
      'navigation.utilityBorder': {
        default: '#e4e0d8',
        _dark: 'whiteAlpha.300',
      },
      'navigation.contextMuted': {
        default: '#6f6a67',
        _dark: 'gray.300',
      },
      'navigation.breadcrumbSeparator': {
        default: '#a29d97',
        _dark: 'gray.400',
      },
      'navigation.breadcrumbCurrent': {
        default: '#403e3a',
        _dark: 'gray.100',
      },
      'navigation.contextActiveBackground': {
        default: '#f0eee6',
        _dark: 'whiteAlpha.100',
      },
      'articleManagement.canvas': {
        default: 'texas.bg.light',
        _dark: 'texas.bg.dark',
      },
      'articleManagement.surface': {
        default: 'white',
        _dark: 'texas.bg.900',
      },
      'articleManagement.subtleSurface': {
        default: '#f7f5ef',
        _dark: 'texas.bg.800',
      },
      'articleManagement.selectedSurface': {
        default: '#fff7f4',
        _dark: 'whiteAlpha.100',
      },
      'articleManagement.border': {
        default: '#d8d3c8',
        _dark: 'whiteAlpha.300',
      },
      'articleManagement.divider': {
        default: '#e3e2de',
        _dark: 'whiteAlpha.200',
      },
      'articleManagement.text': {
        default: '#252525',
        _dark: 'gray.50',
      },
      'articleManagement.mutedText': {
        default: '#656565',
        _dark: 'gray.300',
      },
      'articleManagement.accent': {
        default: 'texas.burntSienna.500',
        _dark: 'texas.sand.30',
      },
      'articleManagement.accentHover': {
        default: 'texasBrand.700',
        _dark: 'texas.sand.10',
      },
      'articleManagement.inputBackground': {
        default: 'gray.10',
        _dark: 'texas.bg.800',
      },
      'articleManagement.inputBorder': {
        default: '#b8b7b2',
        _dark: 'gray.500',
      },
      'articleManagement.inputBorderHover': {
        default: '#888',
        _dark: 'gray.300',
      },
      'status.success': {
        default: '#027a48',
        _dark: 'green.300',
      },
      'status.warning': {
        default: '#92400e',
        _dark: 'orange.300',
      },
      'status.successBackground': {
        default: '#ecfdf3',
        _dark: 'green.900',
      },
      'status.danger': {
        default: '#b42318',
        _dark: 'red.300',
      },
      'status.dangerBackground': {
        default: '#fef3f2',
        _dark: 'red.900',
      },
      'status.dangerBorder': {
        default: '#fecdca',
        _dark: 'red.700',
      },
      'status.archivedText': {
        default: '#5d5955',
        _dark: 'gray.200',
      },
      'status.archivedBackground': {
        default: '#f2f0eb',
        _dark: 'gray.700',
      },
      'complianceDocument.transactionalBackground': {
        default: '#eef3f8',
        _dark: '#23354a',
      },
      'complianceDocument.transactionalText': {
        default: '#35536c',
        _dark: '#d4e3ef',
      },
      'complianceDocument.transactionalBorder': {
        default: '#b9cbd9',
        _dark: '#5f7b94',
      },
      'jobStatus.finishedBackground': {
        default: '#e3eee7',
        _dark: 'green.900',
      },
      'jobStatus.finishedText': {
        default: '#356448',
        _dark: 'green.200',
      },
      'jobStatus.finishedBar': {
        default: '#4f7f62',
        _dark: 'green.300',
      },
      'jobStatus.dangerBackground': {
        default: '#f1dedb',
        _dark: 'red.900',
      },
      'jobStatus.dangerText': {
        default: '#8f3027',
        _dark: 'red.200',
      },
      'jobStatus.dangerBar': {
        default: '#a3372d',
        _dark: 'red.300',
      },
      'jobStatus.waitingBackground': {
        default: '#eeeae2',
        _dark: 'gray.700',
      },
      'jobStatus.waitingText': {
        default: '#6f6a67',
        _dark: 'gray.200',
      },
      'jobStatus.waitingBar': {
        default: '#8a8580',
        _dark: 'gray.300',
      },
      'jobStatus.runningBackground': {
        default: '#f4e6de',
        _dark: 'orange.900',
      },
      'jobStatus.runningText': {
        default: '#9d3d24',
        _dark: 'orange.200',
      },
      'jobStatus.runningBar': {
        default: '#c6502c',
        _dark: 'orange.300',
      },
      'entityDirectory.canvas': {
        default: 'texas.bg.light',
        _dark: 'texas.bg.dark',
      },
      'entityDirectory.surface': {
        default: 'white',
        _dark: 'texas.bg.900',
      },
      'entityDirectory.raisedSurface': {
        default: 'gray.10',
        _dark: 'gray.800',
      },
      'entityDirectory.selectionBackground': {
        default: '#f2e8e3',
        _dark: 'gray.700',
      },
      'entityDirectory.inputBackground': {
        default: 'gray.10',
        _dark: 'texas.bg.800',
      },
      'entityDirectory.border': {
        default: '#d8d3c8',
        _dark: 'gray.600',
      },
      'entityDirectory.text': {
        default: 'texas.bg.900',
        _dark: 'gray.50',
      },
      'entityDirectory.mutedText': {
        default: '#6f6a67',
        _dark: 'gray.300',
      },
      'entityDirectory.avatarText': {
        default: 'white',
        _dark: 'white',
      },
      'entityDirectory.divider': {
        default: '#eeece6',
        _dark: '#eeece6',
      },
      'entityDirectory.archivedBackground': {
        default: '#f2f0eb',
        _dark: '#f2f0eb',
      },
      'entityDirectory.archivedText': {
        default: '#5d5955',
        _dark: '#5d5955',
      },
      'entityDirectory.successBackground': {
        default: '#ecfdf3',
        _dark: '#ecfdf3',
      },
      'entityDirectory.successText': {
        default: '#027a48',
        _dark: '#027a48',
      },
      'entityDirectory.dangerText': {
        default: 'texas.danger.200',
        _dark: 'texas.danger.200',
      },
      'entityDirectory.badgeBackground': {
        default: 'texas.bg.light',
        _dark: 'gray.700',
      },
      'entityDirectory.progressTrack': {
        default: 'gray.100',
        _dark: 'gray.600',
      },
      'entityDirectory.primaryBackground': {
        default: 'texas.burntSienna.500',
        _dark: 'texas.sand.30',
      },
      'entityDirectory.primaryText': {
        default: 'white',
        _dark: '#221f20',
      },
      'entityDirectory.secondaryBackground': {
        default: 'white',
        _dark: 'texas.bg.900',
      },
      'entityDirectory.secondaryBorder': {
        default: '#d8d3c8',
        _dark: 'gray.500',
      },
      'entityDirectory.secondaryText': {
        default: '#403e3a',
        _dark: 'gray.50',
      },
      'inquiryOverview.canvas': {
        default: 'texas.bg.light',
        _dark: 'texas.bg.dark',
      },
      'inquiryOverview.surface': {
        default: 'white',
        _dark: 'texas.bg.900',
      },
      'inquiryOverview.raisedSurface': {
        default: '#f8f7f3',
        _dark: 'texas.bg.800',
      },
      'inquiryOverview.border': {
        default: '#d9d7d0',
        _dark: 'whiteAlpha.300',
      },
      'inquiryOverview.softBorder': {
        default: '#ebe8e2',
        _dark: 'whiteAlpha.200',
      },
      'inquiryOverview.text': {
        default: 'texas.bg.900',
        _dark: 'gray.50',
      },
      'inquiryOverview.mutedText': {
        default: 'gray.500',
        _dark: 'gray.300',
      },
      'inquiryOverview.badgeBackground': {
        default: '#e0ded8',
        _dark: 'whiteAlpha.200',
      },
      'inquiryOverview.activeBadgeBackground': {
        default: 'texas.sand.30',
        _dark: 'texas.sand.700',
      },
      'inquiryOverview.activeBadgeText': {
        default: 'texas.bg.900',
        _dark: 'texas.sand.10',
      },
      'offerDrawer.surface': {
        default: 'white',
        _dark: 'texas.bg.900',
      },
      'offerDrawer.raisedSurface': {
        default: '#f7f6f2',
        _dark: 'texas.bg.800',
      },
      'offerDrawer.rowAlt': {
        default: '#faf9f6',
        _dark: 'whiteAlpha.50',
      },
      'offerDrawer.border': {
        default: '#e4e0d8',
        _dark: 'whiteAlpha.300',
      },
      'offerDrawer.borderStrong': {
        default: '#cfcbc2',
        _dark: 'whiteAlpha.400',
      },
      'offerDrawer.mutedText': {
        default: '#6f6967',
        _dark: 'gray.300',
      },
      'offerDrawer.unavailableBackground': {
        default: 'transparent',
        _dark: 'transparent',
      },
      'offerDrawer.unavailableBorder': {
        default: '#b5b0a7',
        _dark: 'gray.500',
      },
      'offerDrawer.unavailableText': {
        default: '#5f5a54',
        _dark: 'gray.200',
      },
      'offerDrawer.success': {
        default: '#027a48',
        _dark: 'green.300',
      },
      'offerDrawer.successBackground': {
        default: '#ecfdf3',
        _dark: 'green.900',
      },
      'offerDrawer.warning': {
        default: '#c67817',
        _dark: 'orange.300',
      },
      'offerDrawer.warningText': {
        default: '#9a4e08',
        _dark: 'orange.200',
      },
      'offerDrawer.warningBackground': {
        default: '#fff4e5',
        _dark: 'orange.900',
      },
      'offerDrawer.danger': {
        default: '#b42318',
        _dark: 'red.300',
      },
      'offerDrawer.dangerBackground': {
        default: '#fef3f2',
        _dark: 'red.900',
      },
    },
  },
  styles: {
    // Don't replace global styles set by the angular app
    global: () => ({
      ':root': {
        scrollbarColor: 'gray #FFFFFF10',
        scrollbarWidth: 'thin !important',
        _light: { scrollbarColor: 'gray white' },
      },
      '::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
        borderRadius: '12px',
        transition: 'background-color 200ms ease',
      },
      '::-webkit-scrollbar-track:hover': {
        backgroundColor: 'rgba(0,0,0,0.3)',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '12px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555',
      },
      body: {
        bg: null,
        color: null,
        fontFamily: 'Instrument Sans',
      },
      '*::placeholder': {
        color: null,
      },
      '.composition-carousel-list': {
        flexDirection: 'column',
        alignItems: 'baseline',
      },
      '.react-date-picker-close-warning-comp': {
        padding: 0,
        right: '-12px',
      },
      '.react-date-picker-close-warning-comp::after': {
        width: '22px',
        height: '22px',
        backgroundColor: 'red.400',
      },
    }),
  },
  colors: {
    entities: {
      customer: '#329BE2',
      concept: '#7E58C5',
      user: '#DD5F70',
      metadata: '#709900',
      contact: '#01A789',
      supplier: '#4EA83F',
      article: '#C6502C',
      pa: '#E77502',
    },
    gray: {
      10: '#f7f7f7',
      50: '#ededed',
      80: '#e0e0e0',
      100: '#d9d9d9',
      200: '#bdbdbd',
      300: '#999999',
      400: '#787878',
      500: '#5c5c5c',
      600: '#474747',
      700: '#363636',
      800: '#2e2e2e',
      900: '#262626',
    },
    orangeAlpha: { 30010: '#f6ad551a', 50010: '#DD6B201a' },
    redAlpha: { 60010: '#C530301a' },
    texas: {
      secondary: {
        700: '#403e3a',
      },
      normal: {
        100: '#FFFFFF',
      },
      sand: {
        10: '#F8E2C8',
        20: '#F3DABE',
        30: '#E8CBAB',
        50: '#DEBE9A',
        75: '#D0AE89',
        100: '#C6A37C',
        700: '#58432b',
        40085: '#876d50D9',
      },
      burntSienna: {
        50: '#ebc5b9',
        100: '#D95B35',
        200: '#C6502C',
        500: '#C6502C',
      },
      green: {
        100: '#9ade9d',
      },
      danger: {
        50: '#FEF5F2',
        100: '#f27272',
        200: '#B43D18',
      },
      dangerAlpha: { 10010: '#f272721a' },
      warning: {
        100: '#EDD657',
      },
      notification: {
        info: '#26A0F8',
      },
      bg: {
        600: '#474747',
        700: '#3E3E3E',
        800: '#333333',
        900: '#242424',
        90085: '#242424D9',
        950: '#1F1F1F',
        980: '#101010',
        blueTint: {
          100: '#cad0e0',
          700: '#242730',
          800: '#1B1D24',
          900: '#1c1b20',
        },
        dark: '#121212',
        light: '#f0eee6',
      },
    },
    branches: {
      '000': '#6c757d',
      rhk: '#acac90',
      rch: '#d4b483',
      503: '#516055',
      505: '#b07d5d',
      rtr: '#6b8e8d',
      500: '#917e96',
      rin: '#7a957a',
      eco: '#bfa5a1',
      506: '#8a7a66',
      507: '#7a9cc7',
      504: '#5e8e9e',
    },
  },
  components: {
    Accordion: accordionTheme,
    Badge: badgeTheme,
    Text: textTheme,
    Heading: {
      baseStyle: {
        textTransform: 'uppercase',
        fontFamily: 'Barlow',
        color: 'white',
        _light: { color: 'texas.bg.900' },
      },
      variants: {
        drawer: {
          color: 'gray.50',
          fontSize: '1.25rem',
          _light: { color: 'gray.800' },
        },
      },
    },
    FormLabel: {
      baseStyle: {
        fontSize: '0.9em',
        fontWeight: 'normal',
        color: 'gray.200',
        _light: { color: 'texas.bg.700' },
      },
      variants: {
        navbar: {
          _light: {
            color: 'gray.200',
          },
        },
      },
    },
    Input: inputTheme,
    Select: selectTheme,
    Textarea: textareaTheme,
    Button: buttonTheme,
    CloseButton: {
      baseStyle: { borderRadius: '8px' },
    },
    Tabs: tabsTheme,
    Card: cardsTheme,
    Link: linkTheme,
    Menu: menuTheme,
    Popover: popoverTheme,
    Checkbox: checkboxTheme,
    Switch: switchTheme,
    Drawer: drawerTheme,
    Tag: tagTheme,
    TableContainer: {
      background: 'texas.bg.900',
      _light: { background: 'white' },
    },
    Table: tableTheme,
    Modal: modalTheme,
  },
  fonts: {
    barlow: 'Barlow',
    instrumentSans: 'Instrument Sans',
  },
};

export { customTheme };
